import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./user-list.html";

import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { permissionManager } from "../../_shark_jaws/managers/permissionManager";
import userEditView from "./userEditView";
import { userManager } from "../../_shark_jaws/managers/userManager";
import User from "../../_shark_models/User";

class UserListView extends View {
	constructor() {
		super("userListView");

		this.setTemplate(templateContent);
	}

	beforeLoad () {
		permissionManager.getList();
		userManager.getList();
	
		this.set({
			__htmlTitle: "Utenti | IPM HUB",
		});
	}
	
	createNewUserBtn_clickHandler () {
		const editingUser = new User({
			status: 1,
		});

		editingUser.password = "";
		editingUser.__passwordConfirm = "";

		Shark.set({
			editingUser,
			isEditingUser: true,
		});
		Shark.openPage(userEditView);
	}
	
	init () {
		this.addComponents([mainNavComponent]);
	}
	
	singleUserBox_clickHandler (event, data) {
		let selectedUser = Utils.safp(Shark.get("userList"), "guid", data.guid);
		Shark.set({
			editingUser: selectedUser,
			isEditingUser: false
		});
		Shark.openPage(userEditView);
	}
	
	//Dave: Refactor
	userManager_listChangedHandler () {
		let userList = [];
		const currUser = Shark.get("currUser");
	
		if (currUser.hasRole(["areaManager", "projectManager"]) && !currUser.hasRole("internalStaff")) {
			userList = Shark.get("userList").filter(function (item, index) {
				return item.preferences.areaManagerGuid === Shark.get("currUser").guid;
			});
		}
		else if (currUser.hasRole(["internalStaff", "systemAdmin"])) {
			userList = Shark.get("userList");
		}
	
		this.set({
			userList: userList
		});
		Shark.render();
	}
}

const userListView = new UserListView();

Shark.registerView(userListView);

export default userListView;
